import {IRestaurateur} from "../utils/interfaces/IRestaurateur";


const parseRestaurateurs = (item: IRestaurateur) => {
    const a = {
        label: item.name,
        value: item.id,
    }
    return a
}

const parser = {
    parseRestaurateurs,
}

export default parser;